export default __webpack_public_path__ + "static/media/fish_oil3.fb999167.png";